import { Tabs, Tab, TabList, TabPanel, Button } from '@panwds/react-ui'
import DeploymentProfilesTable from './DeploymentProfilesTable'
import { VFC, useState } from 'react'
import LicenseTable from '../../tenancy/components/licenses/LicenseTable'
import styled from 'styled-components'
import { Tooltip } from '@panwds/react-ui-legacy'
import { PencilIcon } from '@panwds/icons'
import {
  LABEL_ACQUISITION_HISTORY,
  LABEL_DEPLOYMENT_PROFILES,
  LABEL_LICENSES_PRODUCT,
  TOOLTIP_EDIT_TENANT
} from '../../tenancy/constants/LabelConstants'
import { getVarValue } from '../../common/utils/Sparky'
import {
  FF_DISABLE_LICENSE_TABLE_EDIT,
  FF_TENANT_ACQUISITIONS
} from '../../common/utils/FeatureFlags'
import AcquisitionsTable from '../../tenancy/components/acquisitionHistory/AcquisitionsTable'
import useReadOnly from '../../common/hooks/useReadOnly'
import { TSG_ACQUISITION_PERMISSION_SET } from '../../iam/constants/IAMConstants'

const enableTenantMove = getVarValue(FF_TENANT_ACQUISITIONS, false)

const CONTAINER = styled.div`
  div[role="tabpanel"] {
    margin: 0 !important;
  }
  div[role="tablist"] {
    border-bottom: none !important;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
  [data-metrics="tabs-metrics"] {
    min-height: unset !important;
    min-width: unset !important;
  }
  #licenseTab {
    border-top-left-radius: 0.5rem
  }
`

export const LicenseTab = 'licenseTab'
export const DeploymentProfileTab = 'deploymentProfileTab'
export const AcquisitionHistoryTab = 'acquisitionHistory'
const OneAppLicensePage: VFC<any> = (props) => {

  const disableEditIcon = getVarValue(FF_DISABLE_LICENSE_TABLE_EDIT, false)
  const { onEditLicenses, disableEdit } = props
  const [activeTabId, setActiveTabId] = useState(LicenseTab)
  const [size] = useState<'sm' | 'md' | 'lg'>('lg')
  const acqReadOnly = useReadOnly(props?.selectedTreeNode?.id, TSG_ACQUISITION_PERMISSION_SET)

  const getTitle = () => {
    return (
      disableEditIcon ? null : <div className='tw-pr-4'>
        <Tooltip label={TOOLTIP_EDIT_TENANT}>
          <Button
            style={{ background: 'transparent' }}
            aria-label={'license-edit'}
            disabled={disableEdit}
            onClick={onEditLicenses}
            appearance='tertiary-clear'
            icon={<PencilIcon />} />
        </Tooltip>
      </div>
    )
  }
  return (
    <CONTAINER>
      <Tabs>
        <div className='tw-border tw-border-gray-300 tw-border-solid tw-border-b-0 tw-rounded-t-lg dark:tw-border-gray-950'>
          <div className='tw-flex tw-justify-between tw-pl-4'>
            {getTitle()}
          </div>
          <TabList
            activeTabId={activeTabId}
            onActiveChange={(nextTabId) => setActiveTabId(nextTabId)}>
            <Tab id={LicenseTab} size={size}>
              {LABEL_LICENSES_PRODUCT}
            </Tab>
            <Tab id={DeploymentProfileTab} size={size}>
              {LABEL_DEPLOYMENT_PROFILES}
            </Tab>
            {enableTenantMove && !acqReadOnly && (
              <Tab id={AcquisitionHistoryTab} size={size}>
                {LABEL_ACQUISITION_HISTORY}
              </Tab>
            )}
          </TabList>
        </div>
        <TabPanel activeTabId={activeTabId} forTabId={LicenseTab}>
          <LicenseTable {...props}></LicenseTable>
        </TabPanel>
        <TabPanel activeTabId={activeTabId} forTabId={DeploymentProfileTab}>
          <DeploymentProfilesTable {...props} />
        </TabPanel>
        {enableTenantMove && !acqReadOnly && (
          <TabPanel activeTabId={activeTabId} forTabId={AcquisitionHistoryTab}>
            <AcquisitionsTable/>
          </TabPanel>
        )}
      </Tabs>
    </CONTAINER>
  )
}

export default OneAppLicensePage
